export const releaseNotesDe: ReleaseNotes = [
    {
        release: '0.1.0',
        date: '2026-02-05',
        type: 'major',
        notes: [
            {
                description: 'Erste Entwicklungsversion der SmartRecycle Plattform.'
            }
        ]
    }
]